import {
  CommandStatusType,
  GetDetailsResponseType,
  ThirdPartyReports,
} from 'QuoteApp/services/endpoints/GetDetails';
import {
  ReportsProviderType,
  reportCommandMappings,
} from 'QuoteApp/services/providers/ReportsProvider';
import { ReportStatus } from './types';

export const getReportStatus = (status: CommandStatusType) => {
  const mapping: Record<CommandStatusType, ReportStatus> = {
    runnable: ReportStatus.Ready,
    not_runnable: ReportStatus.Disabled,
    has_run: ReportStatus.Completed,
    is_running: ReportStatus.Pending,
  };

  return mapping[status];
};

export const getReportStatusMultiple = (
  orderedStatuses: CommandStatusType[]
) => {
  // If any status is ready or pending, use that, otherwise return the last status
  return orderedStatuses.reduce((acc, status) => {
    const thisStatus = getReportStatus(status);
    return [ReportStatus.Ready, ReportStatus.Pending].includes(thisStatus)
      ? thisStatus
      : acc;
  }, getReportStatus(orderedStatuses.slice(-1)[0]));
};

export const getMissingOrInvalidLicenseCount = (
  newDetails: GetDetailsResponseType
): number => {
  return Object.values(newDetails.drivers).filter(driver => {
    const isNotForeign = driver.hasForeignLicense.value !== 'true';
    const hasUSActiveLicense = driver.licenseStatus.value === 'active';

    return (
      driver.driverType !== 'excludedPerson' &&
      isNotForeign &&
      hasUSActiveLicense &&
      (!driver.licenseNumber.value ||
        !driver.licenseState.value ||
        driver.licenseNumber.errors?.length ||
        driver.licenseState.errors?.length)
    );
  }).length;
};

export const getMissingOrInvalidVinCount = (
  newDetails: GetDetailsResponseType
): number =>
  Object.values(newDetails.vehicles).filter(
    vehicle => !vehicle.vin.value || vehicle.vin.errors?.length
  ).length;

export const haveAllRequiredReportsRun = (
  currentReport: ThirdPartyReports,
  reports: ReportsProviderType['reports']
) => {
  const requiredReports: { [key: string]: ThirdPartyReports[] } = {
    [ThirdPartyReports.NcfAndCurrentCarrier]: [
      ThirdPartyReports.DriverDataEnhancement,
      ThirdPartyReports.Ncf,
    ],
    [ThirdPartyReports.Clue]: [
      ThirdPartyReports.DriverDataEnhancement,
      ThirdPartyReports.Ncf,
      ThirdPartyReports.NcfAndCurrentCarrier,
      ThirdPartyReports.DriverDiscovery,
    ],
    [ThirdPartyReports.All]: [
      ThirdPartyReports.DriverDataEnhancement,
      ThirdPartyReports.Ncf,
      ThirdPartyReports.NcfAndCurrentCarrier,
      ThirdPartyReports.DriverDiscovery,
      ThirdPartyReports.Clue,
    ],
  };

  return requiredReports[currentReport].every(requiredReport => {
    const reportKey = reportCommandMappings[requiredReport];

    return reports[reportKey]
      ? reports[reportKey]?.status === 'has_run'
      : // return true to ignore reports that are not included on the application
        true;
  });
};
